import { usePub, useSub } from "@/hooks";
import { theme } from "@/styles/theme";
import { Checkbox, Text } from "@mantine/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useWorkActions } from "./hooks/useWorkActions";
import { useWorkState } from "./hooks/useWorkState";

export const WorkProductionPlanTableHead = () => {
  const { t } = useTranslation();
  const [allChecked, setAllChecked] = useState<boolean>(false);
  const state = useWorkState();
  const actions = useWorkActions();
  const publish = usePub();

  useEffect(() => {
    setAllChecked(state.works.length === state.tempWorks.length);
  }, [state.works, state.tempWorks]);

  useSub("check", () => {
    setAllChecked(state.works.length === state.tempWorks.length);
  });

  useSub("unCheck", () => {
    setAllChecked(false);
  });

  return (
    <thead>
      <tr>
        <th>
          <Checkbox
            checked={allChecked}
            onClick={(e) => {
              if (e.currentTarget.checked) {
                publish("checkAll");
                actions.setWorks((prevWorks) => state.tempWorks);
                setAllChecked(true);
              } else {
                publish("unCheckAll");
                actions.setWorks((prevWorks) => []);
                setAllChecked(false);
              }
            }}
          />
        </th>
        <th>
          <Text fz="sm" fw={500} c="black" ta="center">
            {t("item.name")}
          </Text>
        </th>
        <th>
          <Text fz="sm" fw={500} c="black" ta="center">
            {t("item.code")}
          </Text>
        </th>
        <th>
          <Text fz="sm" fw={500} color={theme.colors?.blue?.[9]} ta="center">
            {t("work.targetQuantity")} / {t("work.completedQuantity")}
          </Text>
        </th>
        <th>
          <Text fz="sm" fw={500} c="black" ta="center">
            {t("productionPlan.code")}
          </Text>
        </th>
      </tr>
    </thead>
  );
};
